import { render, staticRenderFns } from "./TotalizerChart.vue?vue&type=template&id=612e7e78&"
import script from "./TotalizerChart.vue?vue&type=script&lang=ts&"
export * from "./TotalizerChart.vue?vue&type=script&lang=ts&"
import style0 from "./TotalizerChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports